import { PAYMENT_MULTI_STEPS } from '../../utils/steps';
import { StepPerformanceWrapper } from '../atoms/step-performance-wrapper';
import { CareCreditEnrollDisclosureNavigationSwitch } from './care-credit-enroll-disclosure/care-credit-enroll-disclosure-navigation-switch';

export const CareCreditEnrollDisclosure = () => {
  return (
    <StepPerformanceWrapper step={PAYMENT_MULTI_STEPS.careCreditEnrollDisclosure}>
      <CareCreditEnrollDisclosureNavigationSwitch />
    </StepPerformanceWrapper>
  );
};
